import type { DraftDocxEditorHandle } from '@/components/drafts/DraftDocxViewer';
import { apiErrorMessage } from '@/lib/api-client';

export async function saveEditorBuffer(
  editor: DraftDocxEditorHandle,
): Promise<ArrayBuffer | null> {
  return await editor.save({ selective: false });
}

export function draftMovedToVersionNumber(error: unknown): number | null {
  const message = apiErrorMessage(error);
  const match = message?.match(/moved from version \d+ to (\d+)/i)
    ?? message?.match(/moved to version (\d+)/i);
  if (!match?.[1]) return null;
  const versionNumber = Number.parseInt(match[1], 10);
  return Number.isFinite(versionNumber) ? versionNumber : null;
}

export function draftMovedMessage(versionNumber: number): string {
  return `Draft moved to version ${versionNumber}. Refreshed to latest.`;
}
